import { forwardRef, useEffect } from 'react';
import { useAutoPlayVideo, useMorph } from '../model';

export const UserVideo = forwardRef<HTMLVideoElement, {}>((_, ref) => {
  const { isWebcam, bindEvents } = useMorph();

  useEffect(() => {
    return bindEvents();
  }, []);

  const { autoplayAllowed } = useAutoPlayVideo();

  return (
    <div
      className={`${
        isWebcam ? 'ag-opacity-100' : 'ag-opacity-0'
      } ag-absolute ag-border ag-backdrop-blur-[21.5px] ag-flex ag-flex-col ag-justify-center ag-duration-200 ag-items-center
        ag-top-3 ag-left-3 ag-right-auto ag-bottom-auto xl:ag-right-5 xl:ag-bottom-5 xl:ag-top-auto xl:ag-left-auto
      ag-rounded-xl ag-transition-all ag-w-[148px] ag-h-[92px] sm:ag-w-[238px] sm:ag-h-[132px] max-w-md mx-auto aspect-video rounded-2xl overflow-hidden border border-white`}
    >
      <div className="af-flex ag-flex-col ag-justify-center ag-items-center">
        <div className="ag-flex ag-flex-col ag-justify-center ag-items-center ag-transition-all ag-duration-300 ag-w-[68px] ag-h-[68px] sm:ag-w-[98px] sm:ag-h-[98px] ag-overflow-hidden ag-rounded-full ag-border">
          <video
            className={`ag-h-full ag-w-full ag-object-cover`}
            muted={autoplayAllowed}
            playsInline
            ref={ref}
          />
        </div>
      </div>
    </div>
  );
});
